import { combineReducers } from "redux";

import ajaxCounter from "./ajaxCounterReducer";

import settings from "./settingReducer";
import layout from "./layoutReducer";
import exception from "./exceptionReducer";
import validatieStatussen from "./validatieStatusReducer";
import session from "./sessionReducer";
import security from "./securityReducer";
import referentie from "./referentieReducer";
import customModal from "./customModalReducer";
import nieuweSportclubModels from "./nieuweSportclubModelsReducer";
import login from "./loginReducer";

const rootReducer = combineReducers({
	ajaxCounter,
	settings,
	layout,
	validatieStatussen,
	referentie,
	exception,
	session,
	security,
	customModal,
	nieuweSportclubModels,
	login
});

export default rootReducer;